export default __webpack_public_path__ + "static/media/blocklist_icon.f7bcfe39.svg";